/**
 * <bdp-countdown-bar> — faixa de promoção com contagem regressiva.
 *
 * O alvo vem em data-target já com o fuso de Brasília (-03:00), então o
 * instante final é o mesmo para qualquer visitante, esteja onde estiver.
 *
 * A faixa nasce com [hidden] e só aparece depois do primeiro cálculo: assim
 * ninguém vê "--:--:--" nem uma faixa vencida piscando antes do JS rodar.
 */
if (!customElements.get('bdp-countdown-bar')) {
  customElements.define(
    'bdp-countdown-bar',
    class BdpCountdownBar extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.target).getTime();
        this.hideExpired = this.dataset.hideExpired === 'true';

        // data inválida (merchant digitou errado): não arrisca mostrar faixa quebrada
        if (Number.isNaN(this.target)) return;

        this.els = {
          days: this.querySelector('.js-cbar-days'),
          daysWrap: this.querySelector('.js-cbar-days-wrap'),
          daysSep: this.querySelector('.js-cbar-days-sep'),
          hours: this.querySelector('.js-cbar-hours'),
          min: this.querySelector('.js-cbar-min'),
          sec: this.querySelector('.js-cbar-sec'),
          a11y: this.querySelector('.js-cbar-a11y'),
        };

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);

        // o header do Dawn gruda logo abaixo da faixa: publica a altura dela
        this.publishHeight();
        this.resizeObserver = new ResizeObserver(() => this.publishHeight());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.resizeObserver?.disconnect();
        document.documentElement.style.setProperty('--bdp-cbar-height', '0px');
      }

      publishHeight() {
        const h = this.hidden ? 0 : this.offsetHeight;
        document.documentElement.style.setProperty('--bdp-cbar-height', `${h}px`);
      }

      tick() {
        const left = this.target - Date.now();

        if (left <= 0) {
          clearInterval(this.timer);
          if (this.hideExpired) {
            this.hidden = true;
          } else {
            this.paint(0, 0, 0, 0);
            this.hidden = false;
          }
          // sem a faixa, o menu volta a grudar no topo
          this.publishHeight();
          document.dispatchEvent(new CustomEvent('bdp:countdown-ended'));
          return;
        }

        const s = Math.floor(left / 1000);
        this.paint(Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60);
        this.hidden = false;
      }

      paint(d, h, m, s) {
        const pad = (n) => String(n).padStart(2, '0');

        // dias só ocupam espaço enquanto existem — na reta final vira HORAS:MIN:SEGS
        const showDays = d > 0;
        if (this.els.daysWrap) this.els.daysWrap.hidden = !showDays;
        if (this.els.daysSep) this.els.daysSep.hidden = !showDays;
        if (showDays && this.els.days) this.els.days.textContent = pad(d);

        if (this.els.hours) this.els.hours.textContent = pad(h);
        if (this.els.min) this.els.min.textContent = pad(m);
        if (this.els.sec) this.els.sec.textContent = pad(s);

        // leitor de tela: texto estável, sem tagarelar a cada segundo
        if (this.els.a11y) {
          this.els.a11y.textContent = showDays
            ? `Promoção termina em ${d} dias e ${h} horas`
            : `Promoção termina em ${h} horas e ${m} minutos`;
        }
      }
    }
  );
}
